import { offerMeteredTransforms } from "@stores/config/utils";
import { AddOnCard } from "@addons/components/AddOnCard";
import { TransformsAdvancedMeteredUpsell } from "@addons/components/TransformsAdvancedMeteredUpsell";
import { LegacyTransformsManageLink } from "@addons/components/LegacyTransformsManageLink";
import { TransformsUsagePanel } from "@addons/components/TransformsUsagePanel";
import { MoreMenu } from "./MoreMenu";
import { IAddOnSlotProps, IMeteredAddOnDescriptor } from "../types";
import { subscribedBaseFee, transformsTitle } from "../utils";

export function ManageCard({
  addOn: ctx,
}: IAddOnSlotProps<IMeteredAddOnDescriptor>) {
  const { isCloudHosted, subscribed } = ctx;

  // self-hosted sells this tier from a standalone upsell rather than a card
  if (!isCloudHosted && !subscribed) {
    return <TransformsAdvancedMeteredUpsell addOn={ctx} p="xl" />;
  }

  return (
    <AddOnCard
      isYearly={ctx.isYearly}
      productType="transforms-advanced-metered"
      title={transformsTitle(isCloudHosted)}
      detail={isCloudHosted && subscribed ? "Advanced" : null}
      price={subscribedBaseFee(ctx)}
      usage={<TransformsUsagePanel addOn={ctx} />}
      extra={
        offerMeteredTransforms(ctx.config) ? (
          <MoreMenu addOn={ctx} />
        ) : (
          <LegacyTransformsManageLink addOn={ctx} />
        )
      }
    />
  );
}
